import type { InfoLevel } from "@/model/baseTypes";
import { infoLevelInfo } from "@/model/baseTypes";
import { useServerSettingsStore } from "@/store/serverSettings";

/**
 * Returns the state of the load based on the load and capacity.
 */
export function loadState(load: number, capacity: number): InfoLevel {
  if (!load || !capacity) {
    return "default";
  }
  const ratio = (100 * load) / capacity;

  const error = useServerSettingsStore().iterationLoadCritical ?? 100;
  if (ratio > error) {
    return "error";
  }

  const warn = useServerSettingsStore().iterationLoadWarn;
  if (warn && ratio > warn) {
    return "warn";
  }

  return "ok";
}

/**
 * For the load/capacity charts.
 * Returns the load color (CSS color) based on the load and capacity.
 * When there is load, but capacity is 0, return the error color
 */
export function loadColor(load: number, capacity: number): string {
  if (!capacity && load > 0) {
    return infoLevelInfo.error.color;
  }

  return infoLevelInfo[loadState(load, capacity)].color;
}

export function chartMaxY(...values: number[]): number {
  const max = Math.max(0, ...values);
  return max + Math.max(max * 0.15, 1);
}
